module.exports = "/_next/static/images/Pin_locked@3x-edc91f8f54ae9b9eb4ff4e3c0c89ddc9.png";